module.exports = __webpack_public_path__ + "fb531d753523cdb83e1f758447e3a55e.MP3";